import React from "react";
import señora from "../../assets/sueldoInteligente/señora.png";
import lupa from "../../assets/sueldoInteligente/lupa.png";

export default function Section3() {
  return (
    <div className="bg-[#0346A4] text-white px-10 md:px-20 lg:px-40">
      <div className="flex flex-col lg:flex-row gap-10 ">
        <div className="flex-1 text-[#CFE3FB] py-16">
          <h2 className="text-3xl font-bold mb-10 text-white">Tasas y tarifas</h2>

          <div className="mb-10 text-[#CFE3FB]">
            <h3 className="text-xl font-bold mb-2 text-white">Montos y Monedas</h3>
            <p className="mb-4 font-semibold">
              Si esperas recibir giros iguales o superiores a USD 10,000 por transacción o su equivalente en otras divisas,
              no habilites el servicio de abono automático o deshabilítalo si ya estás inscrito.
            </p>
            <p className="font-semibold mb-2">En estos casos, utiliza otros canales del Banco como:</p>
            <ul className="list-disc pl-6 space-y-1 font-semibold">
              <li>Transferencias Internacionales a través de la Sucursal Virtual Personas.</li>
              <li>La Línea telefónica de Comercio Internacional.</li>
            </ul>
          </div>

          <div className="mb-10">
            <h3 className="text-xl font-bold mb-2 text-white">Precio y Tasas de Cambio</h3>
            <ul className="list-disc pl-6 space-y-2 font-semibold">
              <li>
                Giros bancarios desde el exterior: Se aplica la tasa plena o tasa de política definida diariamente por el Banco.
              </li>
              <li>
                Remesas familiares: Se aplica la tasa enviada por la agencia remesadora en el exterior.
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Precio y Tasas de Cambio</h3>
            <ul className="list-disc pl-6 space-y-1 font-semibold">
              <li>USD: Dólar Americano</li>
              <li>EUR: Euro</li>
              <li>GBP: Libra Esterlina</li>
              <li>JPY: Yen Japonés</li>
              <li>CAD: Dólar Canadiense</li>
              <li>MXN: Peso Mexicano</li>
              <li>CHF: Franco Suizo</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col justify-between items-center">
          <img src={lupa} alt="Lupa" className="w-28 md:w-36 mb-6 mt-20" />
          <img src={señora} alt="Mujer usando computador" className="w-48 md:w-64 lg:w-72" />
        </div>
      </div>
    </div>
  );
}
